<script setup>
import { DialogOverlay, useForwardProps } from "reka-ui";

const props = defineProps({
  forceMount: { type: Boolean, default: false },
  asChild: { type: Boolean, default: false },
  as: { type: [String, Object], default: "div" },
});

const forwarded = useForwardProps(props);
</script>

<template>
  <DialogOverlay v-bind="forwarded" class="dialog-overlay">
    <slot />
  </DialogOverlay>
</template>

<style lang="scss" scoped>
@use "@/styles/palette" as p;

.dialog-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  background-color: p.$black-alpha-50;

  &[data-state="open"] {
    animation: overlay-in 0.15s ease-out;
  }

  &[data-state="closed"] {
    animation: overlay-out 0.15s ease-in;
  }
}

@keyframes overlay-in {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes overlay-out {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}
</style>
